import locales from '../locales/locales.json';

export const isRTL = (locale) => {
  const rtlLocales = ['ar-AE', 'ar-BH', 'ar-KW', 'ar-OM', 'ar-QA', 'ar-SA']; // Add new RTL locale values here as needed
  return locales.some(({ value }) => rtlLocales.includes(value) && locale === value);
};
